export const ANGEL_CONTENT_STARTS = 'angel_content_starts'
export const ANGEL_PIF_CLAIM_FREE_TICKET = 'angel-pif-claim-free-ticket'
export const ANGEL_USER_FEATURE_INTRODUCTION = 'angel-user-feature-introduction'
export const GUILD_CONTINUE_WATCHING_COLLECTION = 'angel-guild-continue-watching-collection'
export const SALE_BANNER_DISMISSED = 'angel-sale-banner-dismissed'
export const GUILD_SALE_BANNER_DISMISSED = 'angel-guild-sale-banner-dismissed'
export const FRANCHISE_CTA_MODAL = 'angel-franchise-cta-modal-truth'
export const LIVESTREAM_RSVP = 'livestreamRsvp'
export const ESTIMATED_BACKER = 'estimatedBacker'
export const ESTIMATED_TICKETS_SOLD = 'estimatedTicketsSold'
export const LAST_TICKETS_GIFTED = 'lastTicketsGifted'
export const HAS_SEEN_PREMIERE_PROMO = 'has-seen-premiere-promo'
export const SELECTED_SHOWTIME = 'selectedShowtime'
export const COLLECTIBLE_SHOP_CART = 'collectibleShopCartItems'
export const COLLECTIBLE_MOMENTS_CART = 'collectibleMomentsCartItems'
export const COLLECTIBLE_PACKS_CART = 'collectiblePacksCartItems'
export const EVERFLOW_TRANSACTION_ID = '_ef_transaction_id'
export const TNT_SPLASH_SEEN = 'tnt_splash_seen'
export const AMBASSADOR_SIGNUP = 'ambassadorSignup'
export const DISMISSED_TICKETS_NAV_BANNERS = 'dismissedTicketsNavBanners'
export const GUILD_ATTRIBUTION = 'guild-attribution'
